import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MerchantLayout from "../Layout";
import MerchantHeader from "../Layout/topHeader";
import ShopsList from "../../Shops";
import axios from "axios";
import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select } from "antd";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useSelector } from "react-redux";
const { Option } = Select;

const MerchantShopList = ({ params }: any) => {
  const { merchantInfo } = useSelector((state) => (state as any)?.authReducer);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("JC_MART");
  const [visible, setVisible] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeSearch, setActiveSearch] = useState(false);
  const [shopId, setShopId] = useState<any>();
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/by-merchant?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          `&merchantId=${merchantInfo?.id}` +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            id: shop?.id,
            name: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  useEffect(() => {
    getShopsOptions();
  }, [getShopsOptions]);

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      id: data.shopId,
      merchantId: merchantInfo?.id,
    };

    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Shop Assigned Successfully", "success");
          getShopsOptions(merchantInfo?.id);
          form.resetFields();
          handleOk();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setIsModalVisible(false);
  };

  return (
    <React.Fragment>
      <MerchantLayout merchantId={merchantInfo?.id as string}>
        <div className="product-list-item-area white-bg">
          <MerchantHeader
            leftarea={"Shops List"}
            rightarea={
              <div className="d-flex">
                {/* {activeSearch ? (
                  <Button
                    type="text"
                    danger
                    onClick={() => {
                      setActiveSearch(false);
                    }}
                    className="mr-2"
                  >
                    <ZoomOutOutlined />
                  </Button>
                ) : (
                  <Button
                    type="text"
                    onClick={() => {
                      setActiveSearch(true);
                    }}
                    className="mr-2"
                  >
                    <ZoomInOutlined />
                  </Button>
                )}
                <Button type="primary" danger onClick={showModal}>
                  Add New
                </Button> */}
              </div>
            }
          />
          <ShopsList
            inMerchant={true}
            inMerchantId={merchantInfo?.id}
            activeSearch={activeSearch}
            loading={loading}
          />
        </div>
      </MerchantLayout>

      <Modal
        title="Assign Shop"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item name="shopId">
            <Select
              showSearch
              placeholder="Filter by Shop"
              optionFilterProp="children"
              onChange={(val) => setShopId(val)}
              onSearch={getShopsOptions}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {shopsOptions.list.length ? (
                <Option value={null}>All Shops</Option>
              ) : undefined}
              {shopsOptions.list.map((shop) => (
                <Option value={shop.id} key={shop.id}>
                  {shop.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div className="buttons-container mt-3">
            <Button
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => form?.resetFields()}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default MerchantShopList;
